import { BehaviorSubject } from 'rxjs';

export interface TabModel {
  link: string;
  title: string;
  active: boolean;
  counter?: BehaviorSubject<number>;
}
